<template>
  <div class="pubg-sidebar-wrapper">
    <!--  НАЗВАНИЕ ТУРНИРА  -->
    <SidebarBlock class="mb-4" header-between>
      <template #header>
        <div>
          <span class="block-name">Название турнира</span>
          <h2 class="tournament-title">{{ tournament?.name || 'Отсутсвует' }}</h2>
        </div>
        <CompleteTournamentMiniBlock />
      </template>
      <!-- быстрые переходы: тот же набор, что в шапке редактирования турнира -->
      <template #body>
        <div class="tournament-links">
          <router-link v-if="tournament?.id"
                       :to="{ name: 'tournament_edit', params: { id: tournament.id } }"
                       target="_blank"
                       class="tournament-link"
                       v-b-tooltip.hover.top="'Редактирование турнира'">
            <i class="fa fa-pencil"></i>
          </router-link>
          <router-link v-if="tournament?.id"
                       :to="{ name: 'tournament_teams', params: { id: tournament.id } }"
                       target="_blank"
                       class="tournament-link tournament-link--rel"
                       v-b-tooltip.hover.top="'Заявки и команды'">
            <i class="fa fa-users"></i>
            <span v-if="awaitedEntriesCount" class="tournament-link__badge">
              {{ awaitedEntriesCount > 99 ? '99+' : awaitedEntriesCount }}
            </span>
          </router-link>
          <a v-if="publicLink"
             :href="publicLink"
             target="_blank"
             rel="noopener"
             class="tournament-link"
             v-b-tooltip.hover.top="'Открыть на сайте'">
            <i class="fa fa-external-link"></i>
          </a>
        </div>
      </template>
    </SidebarBlock>
    <!--  СПИСОК ЭТАПОВ  -->
    <SidebarBlock class="mb-4" header-between>
      <template #header>
        <span class="block-name">Этапы</span>
        <button v-if="!isCompletedTournament" class="action-button" @click="isShowAddStageModal = true">Создать этап</button>
      </template>
      <template #body>
        <Tabs :list="stages"
              v-model="selectedStageId"
              :only-view-action="isCompletedTournament"
              @view="viewStage"
              @change="changeStage"
              @edit="editStage"
              @delete="deleteStage">
          <template #item="{ item: { item, isActive } }">
            <div class="tab-label">
              {{ item.name }}
              <template v-if="getIconByStatusStage(item?.status_item?.code)">
                <img v-if="isActive" :src="getIconByStatusStage(item?.status_item?.code).active" v-b-tooltip.hover.top="`${ getIconByStatusStage(item?.status_item?.code).text }`" alt="">
                <img v-else :src="getIconByStatusStage(item?.status_item?.code).black" v-b-tooltip.hover.top="`${ getIconByStatusStage(item?.status_item?.code).text }`" alt="">
              </template>
            </div>
          </template>
          <template #pug><h6>Этапов нет</h6></template>
        </Tabs>
      </template>
    </SidebarBlock>
    <!--  СПИСОК ГРУПП  -->
    <SidebarBlock header-between>
      <template #header>
        <span class="block-name">Группы</span>
        <button v-if="!isCompletedTournament" class="action-button" @click="isShowAddGroupModal = true">Создать группу</button>
      </template>
      <template #body>
        <Tabs :list="selectedStage?.groups || []"
              v-model="selectedGroupId"
              :only-view-action="isCompletedTournament"
              @view="viewGroup"
              @change="changeGroup"
              @edit="editGroup"
              @delete="deleteGroup">
          <template #item="{ item: { item, isActive } }">
            <div class="tab-label">
              <span>
                {{ item.name }}
              </span> 
              <div>
                <span v-b-tooltip.hover.top="'Кол-во добавленных команд'">{{ item.group_results_count }}/{{ item.slot_count }}</span>
                <template v-if="getIconByStatusGroup(item?.status_code?.code)">
                  <img v-if="isActive" :src="getIconByStatusGroup(item?.status_code?.code).active" v-b-tooltip.hover.top="`${ getIconByStatusGroup(item?.status_code?.code).text }`" alt="">
                  <img v-else :src="getIconByStatusGroup(item?.status_code?.code).black" v-b-tooltip.hover.top="`${ getIconByStatusGroup(item?.status_code?.code).text }`" alt="">
                </template>
              </div>
            </div>
          </template>
          <template #pug><h6>Групп нет</h6></template>
        </Tabs>
      </template>
    </SidebarBlock>
    <Modal name="AddStageTournament" title="Создание этапа" v-model="isShowAddStageModal" @submit="submitCreateStage" />
    <Modal name="EditStageTournament" title="Редактирование этапа" v-model="isShowEditStageModal" :params="{ id: selectedStageId }"/>
    <Modal name="DeleteStageTournament" title="Удаление этапа" v-model="isShowDeleteStageModal" :params="{ stage: selectedStage }"/>
    <Modal name="AddGroupTournament" title="Создание группы" v-model="isShowAddGroupModal" :params="{ stage: selectedStage }" @submit="submitCreateGroup" />
    <Modal name="EditGroupTournament" title="Создание группы" v-model="isShowEditGroupModal" :params="{ id: selectedGroupId }"/>
    <Modal name="DeleteGroupTournament" title="Удаление группы" v-model="isShowDeleteGroupModal" :params="{ group: selectedGroup }"/>
    <Modal name="ReviewStageTournament" title="Просмотр этапа" v-model="isShowReviewStageModal" :params="{ stage: selectedStage }" />
    <Modal name="ReviewGroupTournament" title="Просмотр группы" v-model="isShowReviewGroupModal" :params="{ group: selectedGroup }" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import Modal from '@/components/modals/index.vue'
import SidebarBlock from "@/components/Tournament/SidebarBlock.vue";
import Tabs from "@/components/Tournament/Tabs.vue";
import CompleteTournamentMiniBlock from "@/components/Tournament/components/CompleteTournamentMiniBlock.vue";

import checkBlackIcon from '@/assets/icons/check-black.svg'
import xmarkBlackIcon from '@/assets/icons/xmark-black.svg'

/* иконки выбранного пункта: плашка светло-фиолетовая, белое на ней не читается */
import checkVioletIcon from '@/assets/icons/check-violet.svg'
import xmarkVioletIcon from '@/assets/icons/xmark-violet.svg'

import StopBlackIcon from '@/assets/icons/stop-black.svg'
import RotateBlackIcon from '@/assets/icons/rotate-black.svg'
import FinishBlackIcon from '@/assets/icons/finish-black.svg'

import StopVioletIcon from '@/assets/icons/stop-violet.svg'
import RotateVioletIcon from '@/assets/icons/rotate-violet.svg'
import FinishVioletIcon from '@/assets/icons/finish-violet.svg'

export default {
  name: "PUBGSidebar",
  components: {
    Modal,
    SidebarBlock,
    Tabs,
    CompleteTournamentMiniBlock
  },
  computed: {
    ...mapGetters('moduleNewTournament', ['stages', 'selectedStage', 'selectedGroup', 'isCompletedTournament']),
    ...mapState('moduleNewTournament', ['tournament']),
    selectedStageId: {
      get() { return this.$store.state.moduleNewTournament.selectedStageId },
      set(newValue) { this.setFirstLevelData({ name: 'selectedStageId', value: newValue }) }
    },
    selectedGroupId: {
      get() { return this.$store.state.moduleNewTournament.selectedGroupId },
      set(newValue) { this.setFirstLevelData({ name: 'selectedGroupId', value: newValue }) }
    },

    awaitedEntriesCount() {
      return Number(this.tournament?.awaited_entries_count) || 0;
    },

    /** Публичная страница турнира — как в шапке редактирования */
    publicLink() {
      if (!this.tournament?.slug) return '';
      const baseUrl = process.env.NODE_ENV === 'production'
          ? 'https://bigplay.gg/ru/esports-mobile-tournaments/'
          : 'https://client.bigplay.gg/ru/esports-mobile-tournaments/';
      return `${baseUrl}${this.tournament.slug}/`;
    },
  },
  data() {
    return {
      isShowAddStageModal: false,
      isShowEditStageModal: false,
      isShowDeleteStageModal: false,
      isShowReviewStageModal: false,
      isShowAddGroupModal: false,
      isShowEditGroupModal: false,
      isShowDeleteGroupModal: false,
      isShowReviewGroupModal: false,
    }
  },
  methods: {
    ...mapMutations('moduleNewTournament', ['setFirstLevelData']),
    changeStage() {
      this.setFirstGroupId()
      this.$nextTick(() => {
        this.changeGroup()
      })
    },
    editStage(id) {
      const oldSelectedStageId = JSON.parse(JSON.stringify(this.selectedStageId))
      this.selectedStageId = id
      this.setFirstGroupId()
      if(oldSelectedStageId !== id) this.changeGroup()
      this.isShowEditStageModal = true
    },
    deleteStage(id) {
      const oldSelectedStageId = JSON.parse(JSON.stringify(this.selectedStageId))
      this.selectedStageId = id
      this.setFirstGroupId()
      if(oldSelectedStageId !== id) this.changeGroup()
      this.isShowDeleteStageModal = true
    },
    viewStage(id) {
      const oldSelectedStageId = JSON.parse(JSON.stringify(this.selectedStageId))
      this.selectedStageId = id
      this.setFirstGroupId()
      if(oldSelectedStageId !== id) this.changeGroup()
      this.isShowReviewStageModal = true
    },
    submitCreateStage() {
      this.selectedStageId = this.stages.at(-1).id
      this.changeStage()
    },
    async changeGroup() {
      
      if (this.selectedGroupId) {
        await this.$emit('changeWorkspace', 'LoadTeams')
        await this.$store.dispatch('moduleNewTournament/getTeamsByGroup', { id: this.selectedGroupId })
        await this.$emit('changeWorkspace', null)
      }
    },
    editGroup(id) {
      const oldSelectedGroupId = JSON.parse(JSON.stringify(this.selectedGroupId))
      this.selectedGroupId = id
      this.isShowEditGroupModal = true
      if(oldSelectedGroupId !== id) this.changeGroup()
    },
    deleteGroup(id) {
      const oldSelectedGroupId = JSON.parse(JSON.stringify(this.selectedGroupId))
      this.selectedGroupId = id
      this.isShowDeleteGroupModal = true
      if(oldSelectedGroupId !== id) this.changeGroup()
    },
    viewGroup(id) {
      const oldSelectedGroupId = JSON.parse(JSON.stringify(this.selectedGroupId))
      this.selectedGroupId = id
      this.isShowReviewGroupModal = true
      if(oldSelectedGroupId !== id) this.changeGroup()
    },
    submitCreateGroup() {
      this.selectedGroupId = this.selectedStage.groups.at(-1).id
      this.changeGroup()
    },
    setFirstGroupId() {
      this.selectedGroupId = this.selectedStage?.groups?.[0]?.id || 0
    },
    setFirstStageId() {
      this.selectedStageId = this.stages?.[0]?.id || 0
    },
    getIconByStatusStage(statusCode) {
      if (statusCode === 'active') return { black: checkBlackIcon, active: checkVioletIcon, text: 'Активно' }
      if (statusCode === 'deactivated') return { black: xmarkBlackIcon, active: xmarkVioletIcon, text: 'Не активно' }
      return false
    },
    getIconByStatusGroup(statusCode) {
      if (statusCode === 'not_started_status') return { black: StopBlackIcon, active: StopVioletIcon, text: 'Игра не начата' }
      if (statusCode === 'game_process_status') return { black: RotateBlackIcon, active: RotateVioletIcon, text: 'Игра уже идет' }
      if (statusCode === 'ended_status') return { black: FinishBlackIcon, active: FinishVioletIcon, text: 'Игра начата' }
      return false
    },
  },
  mounted() {
    this.setFirstStageId()
    this.changeStage()
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form-tokens";

.pubg-sidebar-wrapper {
  @include tf-tokens-light;

  .tournament-links {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .tournament-link {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid var(--tf-border-strong);
    border-radius: 9px;
    background: var(--tf-bg);
    color: var(--tf-muted);
    font-size: 12px;
    text-decoration: none;
    transition: all .16s ease;

    &:hover {
      border-color: var(--tf-primary);
      background: var(--tf-primary-soft);
      color: var(--tf-primary);
    }

    /* количество заявок, ожидающих решения */
    &__badge {
      position: absolute;
      top: -5px;
      right: -5px;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      border-radius: 999px;
      background: var(--tf-warn);
      color: #fff;
      font-size: 9.5px;
      font-weight: 700;
      line-height: 16px;
      text-align: center;
    }
  }

  .tab-label {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .complete-tournament-text {
    color: green;
    font-weight: 400;
    margin-left: 20px;
  }
}

body.dark-only .pubg-sidebar-wrapper {
  @include tf-tokens-dark;
}
</style>
